import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import { addCompany } from '../../../http/CompaniesApi';

export default function AddCompanyDialog({
  setCompanies,
  companies,
  addCompanyDialogOpen,
  setAddCompanyDialogOpen,
  setErrMessage,
  errMessage,
  setSnackOpen,
}) {
  const initialAddCompanyFormData = Object.freeze({
    symbol: '',
    name: '',
    iconUrl: '',
  });
  const [addCompanyFormData, setAddCompanyFormData] = React.useState(
    initialAddCompanyFormData,
  );

  const handleAddCompany = (event) => {
    event.preventDefault();

    setAddCompanyFormData({
      ...addCompanyFormData,
      [event.target.name]: event.target.value,
    });
  };

  const handleAddCompanySubmit = async (event) => {
    event.preventDefault();

    try {
      const { name, symbol } = addCompanyFormData;
      const companyPayload = { name, symbol };

      // iconUrl is optional; only send it when provided (the API validates it
      // as a valid http(s) URL and rejects an empty string).
      const iconUrl = addCompanyFormData.iconUrl.trim();
      if (iconUrl) companyPayload.iconUrl = iconUrl;

      const { data } = await addCompany(companyPayload);
      setCompanies([...companies, data]);
      setAddCompanyDialogOpen(false);
    } catch (err) {
      setErrMessage(get(err, 'response.data.message', errMessage));
      setSnackOpen(true);
    }
  };

  return (
    <Dialog
      fullWidth
      open={addCompanyDialogOpen}
      onClose={() => setAddCompanyDialogOpen(false)}
    >
      <DialogTitle>Add company</DialogTitle>
      <DialogContent>
        <form onSubmit={handleAddCompanySubmit}>
          <TextField
            name="symbol"
            style={{ margin: 10 }}
            label="Symbol"
            onChange={handleAddCompany}
          />
          <TextField
            name="name"
            style={{ margin: 10 }}
            label="Name"
            onChange={handleAddCompany}
          />
          <TextField
            name="iconUrl"
            style={{ margin: 10 }}
            label="Icon URL (optional)"
            type="url"
            placeholder="https://logo.clearbit.com/example.com"
            onChange={handleAddCompany}
          />
          <Button type="submit">Add company</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
